import React from "react";

const FAQS = [
  {
    q: "What Time Should I Arrive?",
    a: [
      "Please arrive and be seated by 4:00 PM.",
      "The ceremony begins promptly at 4:15 PM. To avoid disruptions, late entry will not be permitted once the ceremony starts.",
      "Thank you for helping us keep this moment peaceful."
    ]
  },
  {
    q: "Is There a Dress Code?",
    a: [
      "Formal / Black Tie Optional.",
      "Women: Knee-length or longer dresses.",
      "Men: Tuxedos or formal suits.",
      "Kindly avoid wearing white, as that is reserved for the bride."
    ]
  },
  {
    q: "Can I Bring a Plus One?",
    a: [
      "Plus ones are by invitation only.",
      "If you received a plus one, please submit your guest’s full name.",
      "Please ensure your guest RSVPs by the deadline.",
      "Plus ones must be approved by the couple before being added to the guest list.",
      "Thank you for helping us keep our celebration intimate."
    ]
  },
  {
    q: "Are Children Invited?",
    a: [
      "This is an invite-only, intimate event.",
      "Select guests may receive one plus one.",
      "Your plus one may be a child or an adult (your choice).",
      "We appreciate your understanding."
    ]
  },
  {
    q: "What is the RSVP Deadline?",
    a: [
      "August 1st, 2026 by 11:59 PM.",
      "Please RSVP by the deadline so we can plan accordingly.",
      "If we do not receive your RSVP by then, your attendance will be marked as 'No'.",
      "If applicable, your plus one must also RSVP by the deadline."
    ]
  },
  {
    q: "What if I Do Not RSVP In Time?",
    a: [
      "RSVPs submitted after the deadline will be marked as 'No'.",
      "This also applies to plus one guests.",
      "If your plus one is not confirmed by the deadline, they will also be marked as 'No'.",
      "Thank you for understanding as we finalize our guest count."
    ]
  },
  {
    q: "Where Do I Park?",
    a: [
      "Ceremony: Parking is not complimentary. Guests will need to secure their own parking at the nearby paid garage. Street parking is subject to local rules and availability.",
      "Reception: Complimentary parking will be available in the attached parking lot."
    ]
  },
  {
    q: "Will There Be an Open Bar?",
    a: [
      "The reception will be BYOB.",
      "Soft drinks will be provided.",
      "Please note that no alcohol is permitted at the ceremony location."
    ]
  },
  {
    q: "Do You Have a Wedding Registry?",
    type: "registry"
  },
  {
    q: "Can I Take Photos or Record During the Ceremony?",
    a: [
      "Our ceremony will be unplugged.",
      "Please refrain from taking photos or videos from 4:00 PM until the ceremony concludes.",
      "Kindly silence or turn off all devices.",
      "Our professional photographer and videographer will capture every special moment.",
      "Thank you for helping us keep this moment intimate and meaningful."
    ]
  }
];

function FAQ() {
  return (
    <div className="page">
      <section className="section section-soft fade-up">
        <div className="section-inner">
          <h2>FAQ</h2>

          <p className="section-intro">
            Quick answers to help you plan comfortably.
          </p>

          <div className="faq-native">
            {FAQS.map((item) => (
              <details className="faq-details" key={item.q}>
                <summary className="faq-summary">
                  <span>{item.q}</span>
                  <span className="faq-plus" aria-hidden="true">
                    +
                  </span>
                </summary>

                <div className="faq-content">
                  {item.type === "registry" ? (
                    <div className="faq-registry-answer">
                      <ul className="faq-bullets">
                        <li>
                          Your presence at our wedding is truly the greatest
                          gift we could ask for.
                        </li>

                        <li>
                          For those who would like gift ideas, we have created
                          a wedding registry with a selection of items to help
                          us begin this exciting new chapter together.
                        </li>

                        <li>
                          If you prefer to give a monetary gift, we are also
                          gratefully accepting contributions toward our future
                          home and honeymoon fund.
                        </li>

                        <li>
                          Every gift, whether selected from our registry or
                          given toward our future together, is sincerely
                          appreciated and means the world to us.
                        </li>
                      </ul>

                      <a
                        className="registry-link"
                        href="https://www.amazon.com/wedding/guest-view/2MDD0N92VBNPW"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Our Registry
                      </a>
                    </div>
                  ) : (
                    <ul className="faq-bullets">
                      {item.a.map((point, index) => (
                        <li key={`${item.q}-${index}`}>
                          {point}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default FAQ;